import Vrouter from "@/router"
import { getResource } from '@/api/csa-admin/resource'

export default {
  async mounted(el, binding) {
    el.style.display = 'none'

    const route = Vrouter.currentRoute.value

    const { value, arg } = binding

    let res = await getResource({
      routeName: arg ? arg : route.name,
      userId: sessionStorage.getItem('userId')
    })

    if (!(res.map((item) => item.code).includes(value))) {
      const comment = document.createComment(' ');
      el.parentNode?.replaceChild(comment, el);
    } else {
      el.style.display = ''
    }
  }
}
